export default __webpack_public_path__ + "static/media/Megosu - Lukas Bazle - 6.0da71a82.mp4";